var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenContainer fullscreen-wrapper"},[_c('iframe',{attrs:{"src":"https://aperio.games/app/","width":"100%","height":"100%","frameborder":"0","id":"app"}})])}
var staticRenderFns = []

export { render, staticRenderFns }